import React from 'react';
import { Avatar } from '@socialchorus/shared-ui-components';
import { AssistantAction } from '../../assistant';
import { AvatarCard } from '../../../models/chatbot/types';
import { convertToActionable } from '../../../lib/action-utils';

interface AvatarRefCardProps {
  card: AvatarCard;
}

const AvatarRefCard: React.FC<AvatarRefCardProps> = ({ card }) => {
  const actionable = convertToActionable(card.action, card.heading);

  return (
    <AssistantAction
      action={actionable}
      className="chatbot__reference-card"
      onClick={() => {}}
    >
      <div className="chatbot__reference-card-content">
        <div className="chatbot__reference-card-body">
          <div className="chatbot__reference-avatar">
            <Avatar
              alt={card.avatar.alt_text}
              size="medium"
              shape="circle"
              imgSrc={card.avatar.url || undefined}
            />
          </div>
          <div className="chatbot__reference-text">
            <h4 className="chatbot__reference-title">{card.heading}</h4>
            {card.subheading && (
              <p className="chatbot__reference-description">
                {card.subheading}
              </p>
            )}
          </div>
        </div>
      </div>
    </AssistantAction>
  );
};

export default AvatarRefCard;
